"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var stimulus_1 = require("stimulus");
var DetailCardController = /** @class */ (function (_super) {
    __extends(DetailCardController, _super);
    function DetailCardController() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.connect = function () {
            _this.toggleButtonTarget && _this.toggleButtonTarget.addEventListener('click', _this.toggleItemList);
        };
        _this.toggleItemList = function () {
            if (!_this.innerDetailListTarget || !_this.toggleButtonTarget) {
                return;
            }
            $(_this.innerDetailListTarget).toggleClass("open");
            $("html,body").animate({
                scrollTop: $(_this.innerDetailListTarget).offset().top - 150
            }, 500);
            $(_this.toggleButtonTarget).text($(_this.innerDetailListTarget).hasClass("open") ? "とじる" : "詳細を見る");
        };
        return _this;
    }
    DetailCardController.targets = ['innerDetailList', 'toggleButton'];
    return DetailCardController;
}(stimulus_1.Controller));
exports.default = DetailCardController;
